<div class="row justify-content-start m-0">

  @for (item of beneficiarios; track item) {
    <div class="col-sm-4">
      <div class="card">
        <div class="card-header">
          {{item.NOME_BENEF}}
        </div>
        <div class="card-body p-0">
          <ul class="">
            <li class="list-group-item py-1 py-lg-2">CPF: {{item.DCR_CPF_BENEF}}</li>
            <li class="list-group-item py-1 py-lg-2">Data Nascimento: {{item.DTA_NASC_BENEF| date:'dd/MM/yyyy'}}</li>
            <li class="list-group-item py-1 py-lg-2">Email: {{item.DCR_EMAIL_BENEF}} </li>
            <li class="list-group-item py-1 py-lg-2">Telefone: ({{item.DCR_DDD_CELULAR_BENEF}}) {{item.DCR_CELULAR_BENEF}} </li>
            <li class="list-group-item py-1 py-lg-2">Grau Parentesco: {{item.DCR_PARENTESCO_EXT}}</li>
            <li class="list-group-item py-1 py-lg-2"><strong>Percentual: {{item.PRC_BENEF}}%</strong></li>
          </ul>
        </div>
        <div class="card-footer clearfix">
          <span class="py-1 py-lg-2 text-muted" style="font-size: 14px;">Última Alteração: {{item.TIM_ALTERACAO| date:'dd/MM/yyyy HH:mm:ss'}}</span>
          <button class="btn btn-danger btn-sm float-right" data-toggle="modal" data-target="#assinaturaModal" (click)="benefSelecionado=item">Remover</button>
        </div>
      </div>
    </div>
  }

</div>

@if (percentualTotal<100) {
  <div class="row justify-content-center m-0 mt-3">
    <div class="col-md-8 clearfix">
      <div class="alert alert-warning" role="alert">
        Você deve chegar ao percentual de 100%, cadastre mais beneficiários ou aumente o percentual dos beneficiários atuais
      </div>
    </div>
  </div>
}

<div class="row justify-content-end m-0 mt-3">
  <div class="col-md-6 clearfix">
    <div class="recaptcha-container">

    </div>

    <button class="btn btn-success float-right" data-toggle="modal" data-target="#benefeciarioModal" [disabled]="percentualFaltante<=0">Inserir</button>

    <div class="float-right mr-5 py-2">
      Percentual Total: <strong>{{percentualTotal}} %</strong>
    </div>
  </div>
</div>


<div id="benefeciarioModal" class="modal fade" role="dialog">
  <div class="modal-dialog" [formGroup]="form">

    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">Beneficiario</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12 mb-2">
            <label>Nome</label>
            <input type="text" class="form-control" formControlName="nomeBenef">
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <label>CPF</label>
            <input type="text" maxlength="17" mask="000.000.000-00" class="form-control" formControlName="CPFBenef">

            <label>Email</label>
            <input type="email" class="form-control" formControlName="emailBenef">

            @if (!this.form.get('emailBenef').valid) {
              <div>
                @if (this.form.get('emailBenef').dirty) {
                  <div>
                    <small class="text-danger">
                      Email Inválido
                    </small>
                  </div>
                }
              </div>
            }

          </div>
          <div class="col-12 col-lg-6 mb-2">
            <label>Data Nascimento</label>
            <input
              type="text"
              class="form-control"
              [dropSpecialCharacters]="false"
              mask="00/00/0000"
              maxlength="10"
              formControlName="dtaNascBenef"
              placeholder="dd/mm/aaaa"
            >
            <label>Grau Parentesco</label>
            <select class="form-control" formControlName="codParentesco">
              <option disabled value=null>Parentesco/Afinidade</option>
              @for (parent of parentescos; track parent) {
                <option [value]="parent.COD_PARENTESCO">{{parent.DCR_PARENTESCO_EXT}}</option>
              }
            </select>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <label>Celular</label>
            <input type="text" class="form-control" maxlength="16" mask="(00) 0 0000-0000" formControlName="celularCompletoBenef">

            @if (!this.form.get('celularCompletoBenef').valid) {
              <div>
                @if (this.form.get('celularCompletoBenef').dirty) {
                  <div>
                    <small class="text-danger">
                      Celular Inválido
                    </small>
                  </div>
                }
              </div>
            }

          </div>
          <div class="col-12 col-lg-6 mb-2">
            <label>Percentual (%)</label>
            <input type="number" maxlength="3" placeholder="Valor Máximo: {{percentualFaltante}} %" class="form-control" formControlName="prcBenef" (input)="validarPercentual($event.target.value)" (click)="validarPercentual($event.target.value)">

            @if (msgErroPercentual!=null) {
              <div class="text-danger">
                {{msgErroPercentual}}
              </div>
            }

          </div>
        </div>
      </div>
      <div class="modal-footer">
        <ngx-recaptcha2
          style="margin-right: 8rem;"
          siteKey="6LdaOQosAAAAACzh0-1jawKR-9YFKh57oiyDVaMg"
          [useGlobalDomain]="false"
          formControlName="recaptchaV2Token">
        </ngx-recaptcha2>

        <div class="input-group w-30" style="width: 300px;">

          <input type="password" class="form-control" placeholder="Assinatura Eletrônica" formControlName="assinatura">


          <div class="input-group-append">

            <button class="btn btn-success" type="button" (click)="inserir()" [disabled]="!form.valid || msgErroPercentual!=null || loadingInserir">
              Salvar
              @if (loadingInserir) {
                <i class="fas fa-spinner fa-spin"></i>
              }
            </button>
          </div>
        </div>
        <button type="button" class="btn btn-primary" data-dismiss="modal">Cancelar</button>

      </div>

    </div>
  </div>
</div>

<div id="assinaturaModal" class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm" style="max-width: 600px;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Assinatura Eletrônica</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">

        <div class="input-group">
          <input type="password" class="form-control" placeholder="Assinatura Eletrônica" [(ngModel)]="assinatura">
          <div class="input-group-append">
            <button class="btn btn-danger" type="button" (click)="remover()" [disabled]="assinatura==''">
              Excluir Beneficiário
              @if (loadingRemover) {
                <i class="fas fa-spinner fa-spin"></i>
              }
            </button>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>
